<template>
  <div class="body">
      <OBJECT ref="remote" classid="clsid:1E125331-B4E3-4EE3-B3C1-24AD1A3E5DEB"
              WIDTH="100%" HEIGHT="100%">
          <FONT COLOR=red SIZE=5> Not installed plugin,Please click<a
                  href='http://cn-download.eyecloud.so/download/application/ipcamax.exe'>here</a>download
              and install.</FONT>
      </OBJECT>
  </div>
</template>

<script>


export default {
  name: "Preview",
  data() {
    return {
      uid: '',
      password: '',
      iframeWin: {},
      name: '',
      par: '',
      data: '',
      src:'',
      preActTime:0,
      bNeedStop:false,
      nPort:81,
      szAuthAcc:"admin",
      nImgW:320,
      nImgH:240,
      nDevType:922,
      bInLan:0
    }
  },
  components: {},
  created() {
    // this.ShowDev();
  },
  methods: {
    ShowDev() {
      // var szDevIP = this.$route.query.uid
      // var szAuthPwd =this.$route.query.password
      // var szDevName=this.$route.query.name
      var remote=this.$refs.remote
      var szDevIP = 'VSTG622058YNXKD';
      var szAuthPwd ="888888";
      var szDevName="乐庭展厅";
      try {
          remote.ClearDevs();
      } catch (exception) {
          return;
      }
      remote.Lan = "cn";  //language cn:chinese en:english jp:japanese
      remote.ShowOSDName = 1;//whether to show ipcam caption on the video
      remote.SwitchLayout("1 x 1");
      remote.Width = this.nImgW;  //width of the window
      remote.Height = this.nImgH; //height of the window
      remote.ShowToolBar = 1;//whether to show toolbar
      remote.AddDev4(this.nDevType, this.bInLan, szDevIP, this.nPort, szDevName, this.szAuthAcc, szAuthPwd, 1);
      remote.Listen = 1;//whether to play soound
      remote.TurnImg = 0;   //whether reverse video
      remote.ConnectAll();
      remote.Start();
    },
    StopAction() {
        this.$refs.remote.PTZ(1, 1, -1, 0, 0, 0);
        this.bNeedStop = false;
    },
    setAction(action, time) {
        if ((action == -1) && (!this.bNeedStop))
            return 0;

        var now_time = new Date();
        if ((this.preActTime > 0) && (now_time - this.preActTime < 300)) {
            if (action == -1) {
                setTimeout('StopAction();', 500);
                return 0;
            } else
                return 0;
        }
        this.$refs.remote.PTZ(1, 1, action, time, 0, 0);
        this.bNeedStop = action != -1;
        this.preActTime = now_time;
    }
  },
  mounted() {
    this.ShowDev();
  }
}
</script>

<style lang="scss" scoped>
.body{
  width:100%;
  height:98vh;
  display: flex;
  justify-content:center;
}
</style>
